<style>
  td {
    border: 2px solid;
    color: transparent;
  }

  td span {
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .MoeinProtocolClass:hover {
    color: #007bff;
    font-weight: bolder;
  }

  .MoeinFormClass:hover {
    color: #dc3545;
    font-weight: bold;
  }

  .MoeinFileClass:hover {
    color: #28a745;
    font-weight: bold;
  }

  .MoeinFormClass2 {
    color: #dc3545;
    font-weight: bold;
  }
</style>


<style>
  .Moein_card {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 100%;
    border-radius: 5px;

    transform-style: preserve-3d;
    cursor:pointer
  }

  .Moein_card img{
    opacity: 0.5;
    border-radius: 5px 5px 0 0;
  }

  .Moein_card:hover {
    box-shadow: 0 16px 24px 0 rgba(0,0,0,0.2);

  }

  .Moein_card:hover img{
   opacity: 1;
    transition: 1.5s;
    transform: rotateY(20deg)
  }

  .Moein_container {
    padding: 2px 16px;
  }
</style>

<div style="margin: auto;padding:0px 50px;" [hidden]="Selected_Chart_Level.id>0">

  <table style="background-image: url(assets/17025/17025.png);background-repeat: round;width: 100%;height: 500px;">

    <!-- 1 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td colspan="13" rowspan="3">
        <span (click)="OnSetView(180,0)"></span>
      </td>

      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 2 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>

      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 3 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>

      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 4 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td colspan="13" rowspan="3">
        <span (click)="OnSetView(179,0)"></span>
      </td>

      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>

      <td colspan="7" rowspan="3">
        <span (click)="OnSetView(183,0)"></span>
      </td>

      <td>38</td>

      <td colspan="8" rowspan="3"></td>

      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 5 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>

      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>

      <td>38</td>

      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 6 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>

      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>

      <td>38</td>

      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 7 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td>14</td>
      <td>15</td>
      <td>16</td>
      <td>17</td>
      <td>18</td>
      <td>19</td>
      <td>20</td>
      <td>21</td>
      <td>22</td>
      <td>23</td>
      <td>24</td>
      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 8 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td colspan="11" rowspan="2">
        <span (click)="OnSetView(181,0)"></span>
      </td>

      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>

      <td colspan="15" rowspan="2">
        <span (click)="OnSetView(13,0)"></span>
      </td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 9 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>

      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 10 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td>14</td>
      <td>15</td>
      <td>16</td>
      <td>17</td>
      <td>18</td>
      <td>19</td>
      <td>20</td>
      <td>21</td>
      <td>22</td>
      <td>23</td>
      <td>24</td>
      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 11 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td colspan="6" rowspan="2">
        <span (click)="OnSetView(174,0)"></span>
      </td>

      <td>16</td>
      <td colspan="7" rowspan="2">
        <span (click)="OnSetView(175,0)"></span>
      </td>
      <td colspan="6" rowspan="2">
        <span (click)="OnSetView(182,0)"></span>
      </td>

      <td>30</td>

      <td colspan="7" rowspan="2">
        <span (click)="OnSetView(154,0)"></span>
      </td>

      <td>38</td>
      <td colspan="7" rowspan="2">
        <span (click)="OnSetView(153,0)"></span>
      </td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 12 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>

      <td>16</td>

      <td>30</td>

      <td>38</td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 13 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td>14</td>
      <td>15</td>
      <td>16</td>
      <td>17</td>
      <td>18</td>
      <td>19</td>
      <td>20</td>
      <td>21</td>
      <td>22</td>
      <td>23</td>
      <td>24</td>
      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 14 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td>14</td>
      <td>15</td>
      <td>16</td>
      <td>17</td>
      <td>18</td>
      <td>19</td>
      <td>20</td>
      <td>21</td>
      <td>22</td>
      <td>23</td>
      <td>24</td>
      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 15 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>

      <td colspan="5" rowspan="7">
        <span (click)="OnSetView(173,0)"></span>
      </td>

      <td>14</td>

      <td colspan="4" rowspan="7">
        <span (click)="OnSetView(172,0)"></span>
      </td>

      <td>19</td>

      <td colspan="4" rowspan="7">
        <span (click)="OnSetView(171,0)"></span>
      </td>

      <td>24</td>

      <td colspan="4" rowspan="7">

      </td>

      <td colspan="5" rowspan="7">
        <span (click)="OnSetView(169,2)"></span>
      </td>

      <td colspan="3" rowspan="7">

      </td>

      <td>37</td>

      <td colspan="4" rowspan="7">
        <span (click)="OnSetView(168,0)"></span>
      </td>

      <td colspan="4" rowspan="7">
        <span (click)="OnSetView(144,3)"></span>
      </td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 16 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>

      <td>14</td>

      <td>19</td>

      <td>24</td>

      <td>37</td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 17 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>

      <td>14</td>

      <td>19</td>

      <td>24</td>

      <td>37</td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 18 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>

      <td>14</td>

      <td>19</td>

      <td>24</td>

      <td>37</td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 19 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>

      <td>14</td>

      <td>19</td>

      <td>24</td>

      <td>37</td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 20 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>

      <td>14</td>

      <td>19</td>

      <td>24</td>

      <td>37</td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 21 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>

      <td>14</td>

      <td>19</td>

      <td>24</td>

      <td>37</td>

      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 22 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td>14</td>
      <td>15</td>
      <td>16</td>
      <td>17</td>
      <td>18</td>
      <td>19</td>
      <td>20</td>
      <td>21</td>
      <td>22</td>
      <td>23</td>
      <td>24</td>
      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 23 -->
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
      <td>4</td>
      <td>5</td>
      <td>6</td>
      <td>7</td>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>11</td>
      <td>12</td>
      <td>13</td>
      <td>14</td>
      <td>15</td>
      <td>16</td>
      <td>17</td>
      <td>18</td>
      <td>19</td>
      <td>20</td>
      <td>21</td>
      <td>22</td>
      <td>23</td>
      <td>24</td>
      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
      <td>47</td>
      <td>48</td>
      <td>49</td>
      <td>50</td>
    </tr>

    <!-- 24 -->
    <tr>
      <td colspan="7" rowspan="9">
        <span (click)="OnSetView(149,0)"></span>
      </td>

      <td>8</td>
      <td>9</td>

      <td colspan="10" rowspan="2">

      </td>

      <td>20</td>

      <td colspan="4" rowspan="2"></td>

      <td>25</td>

      <td colspan="20" rowspan="2">10</td>

      <td>46</td>

      <td colspan="4" rowspan="9">
        <span (click)="OnSetView(150,0)"></span>
      </td>
    </tr>

    <!-- 25 -->
    <tr>
      <td>8</td>
      <td>9</td>

      <td>20</td>

      <td>25</td>

      <td>46</td>
    </tr>

    <!-- 26 -->
    <tr>
      <td>8</td>
      <td>9</td>
      <td>10</td>
      <td>10</td>
      <td>10</td>
      <td>10</td>
      <td>10</td>
      <td>15</td>
      <td>16</td>
      <td>17</td>
      <td>18</td>
      <td>19</td>
      <td>20</td>
      <td>21</td>
      <td>22</td>
      <td>23</td>
      <td>24</td>
      <td>25</td>
      <td>26</td>
      <td>27</td>
      <td>28</td>
      <td>29</td>
      <td>30</td>
      <td>31</td>
      <td>32</td>
      <td>33</td>
      <td>34</td>
      <td>35</td>
      <td>36</td>
      <td>37</td>
      <td>38</td>
      <td>39</td>
      <td>40</td>
      <td>41</td>
      <td>42</td>
      <td>43</td>
      <td>44</td>
      <td>45</td>
      <td>46</td>
    </tr>

    <!-- 27 -->
    <tr>
      <td>8</td>
      <td>9</td>
      <td colspan="5" rowspan="6">

      </td>

      <td>15</td>

      <td colspan="5" rowspan="6">
        <span (click)="OnSetView(178,0)"></span>
      </td>

      <td colspan="4" rowspan="6">10</td>

      <td colspan="5" rowspan="6">
        <span (click)="OnSetView(167,0)"></span>
      </td>

      <td colspan="4" rowspan="6"></td>

      <td colspan="4" rowspan="6">
        <span (click)="OnSetView(164,1)"></span>
      </td>

      <td colspan="5" rowspan="6">
        <span (click)="OnSetView(163,0)"></span>
      </td>

      <td colspan="4"  rowspan="6">
        <span (click)="OnSetView(162,4)"></span>
      </td>

    </tr>

    <!-- 28 -->
    <tr>
      <td>8</td>
      <td>9</td>

      <td>15</td>

    </tr>

    <!-- 29 -->
    <tr>
      <td>8</td>
      <td>9</td>

      <td>15</td>
    </tr>

    <!-- 30 -->
    <tr>
      <td>8</td>
      <td>9</td>

      <td>15</td>
    </tr>

    <!-- 31 -->
    <tr>
      <td>8</td>
      <td>9</td>

      <td>15</td>
    </tr>

    <!-- 32 -->
    <tr>
      <td>8</td>
      <td>9</td>

      <td>15</td>
    </tr>

  </table>

</div>

<div class="col-md-12 mb-30" [hidden]="Selected_Chart_Level.id==0">
  <div class="card card-statistics h-100">
    <div class="card-body">

      <h5 class="card-title border-0 pb-0" style="float: left;">
        <span>
          {{Selected_Chart_Level.title}} ({{Selected_Chart_Level.code}})
        </span>
        <span *ngIf="Procssing">(Loading information...)</span>
      </h5>

      <div style="float: right;">
        <button type="button" (click)="openModal_Search(templateSearch)" class="btn btn-info"
          style="margin-right: 5px;"><i class="fa  fa-search"></i> Search
          Information </button>

        <button *ngIf="Chat_Id_Filter" (click)="OnBack_Protocol()" type="button" class="btn btn-danger"
          style="margin-right: 5px;"><i class="fa fa-list-alt"></i> Back to Procedure
        </button>

        <button (click)="OnBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back to
          17025
        </button>
      </div>
      <div style="clear: both;"></div>

      <hr />

      <div class="row">
        <div class="form-group col-md-10" *ngIf="!Chat_Id_Filter">

          <div class="row">

            <div *ngFor="let item of Child_Protocol_DataList" class="form-group col-md-3">
              <div class="Moein_card">
                <a href="{{BaseUrl}}{{item.src}}" target="_blank">

                  <img src="assets/17025/read.png" style="width:100%">
                  <div class="Moein_container">
                    <p><b>{{item.title}}</b></p>
                    <p>{{item.code}}</p>
                  </div>
                </a>
              </div>
            </div>

          </div>

        </div>

        <div class="form-group col-md-10" *ngIf="Chat_Id_Filter">

          <div class="row">

            <div *ngFor="let item of File_DataList
                  |filter:Chat_Id_Filter_Main:'dsc'
                  | paginate: {
                  id: 'DataList_FeildTable',
                  itemsPerPage: 12,
                  currentPage: page_File,
                  totalItems: (File_DataList|filter:Chat_Id_Filter_Main:'dsc').length}" class="form-group col-md-3">

              <div class="Moein_card">
                <a href="{{BaseUrl}}{{item.src}}" target="_blank">
                  <img src="assets/17025/pdf.png" *ngIf="item.src.includes('.pdf')" style="width:100%">
                  <img src="assets/17025/excel.png" *ngIf="item.src.includes('.xlsx')" style="width:100%">
                  <img src="assets/17025/mpx.png" *ngIf="item.src.includes('.mpx')" style="width:100%">
                  <img src="assets/17025/behfa.png" *ngIf="item.src.includes('Protocol17025Print')" style="width:100%">
                  <img src="assets/17025/png.png" *ngIf="item.src.includes('.png') || item.src.includes('.jpg')" style="width:100%">
                  <img src="assets/17025/zip.png" *ngIf="item.src.includes('.zip') || item.src.includes('.rar')" style="width:100%">
                  <img src="assets/17025/word.png" *ngIf="item.src.includes('.doc') || item.src.includes('.docx')" style="width:100%">
                  <div class="Moein_container">
                    <p><b>{{item.title}}</b></p>
                  </div>
                </a>
              </div>

            </div>

          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous"
                (pageChange)="page_File = $event">
              </pagination-controls>
            </div>
          </div>



        </div>

        <div class="form-group col-md-2" style="border-left: 2px solid;">

          <div class="row">
            <div class="form-group col-md-12">

              <input type="text" class="form-control" [(ngModel)]="form_search_txt" placeholder="Search forms...">
            </div>
          </div>

          <div style="overflow-y: scroll;height: 300px;">
            <div class="form-group col-md-12">

              <div *ngFor="let item of Child_Form_DataList|filter:form_search_txt:'dsc'" class="row">
                <div class="form-group col-md-12">

                  <div class="card card-statistics MoeinFormClass" *ngIf="OnGet_Chat_Id()!=item.id"
                    (click)="OnSetChat_Id(item.id)" style="padding: 5px; cursor: pointer;">
                    <div style="text-align: center;">
                      <i class="fa fa-file-text highlight-icon" style="font-size: 35px;"></i>
                    </div>
                    <div style="width: 100%;text-align: center;">
                      <p class="card-text text-dark">
                        {{item.title}}
                        <br />
                        {{item.code}}
                      </p>


                    </div>
                  </div>

                  <div class="card card-statistics MoeinFormClass2" *ngIf="OnGet_Chat_Id()==item.id"
                    (click)="OnSetChat_Id(item.id)" style="padding: 5px; cursor: pointer;">
                    <div style="text-align: center;">
                      <i class="fa fa-file-text highlight-icon" style="font-size: 35px;"></i>
                    </div>
                    <div style="width: 100%;text-align: center;">
                      <p class="card-text text-dark">
                        {{item.title}}
                        <br />
                        {{item.code}}
                      </p>


                    </div>
                  </div>

                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  </div>
</div>

<ng-template #templateSearch>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Form Search</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Search.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" [hidden]="Selected_Chart_View!=2 && Selected_Chart_View!=3">
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Time Range</label>
        <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
          <option value="1">Apply</option>
          <option value="0">Do Not Apply</option>
        </select>
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Start Date</label>
        <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
          [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">End Date</label>
        <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
          [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Keyword</label>
        <input [(ngModel)]="txt_Search" name="txt_Search" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
    <div class="row" *ngIf="Selected_Chart_Level.id>0">
      <div class="form-group col-md-12" style="padding: 10px;">
        <div style="max-height: 400px;overflow-y: scroll;border: 1px solid;">
          <app-Protocol17025Cat_Check
            [DataList_Protocol17025Cat]="DataList_Protocol17025Cat"
            [Selected_Protocol17025Cat]="Selected_Tag" (On_Get_Selected_Tag)="OnGet_Selected_Tag($event)">

          </app-Protocol17025Cat_Check>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="OnSetDate_ReadView(datepickerInputStart.value,datepickerInputEnd.value)"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search
      Information </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Search.hide()">Close</button>
  </div>
</ng-template>
